module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/logo-selma-cybermonday.71fa2a63.png";